import React from 'react'
import ReceiptModal from "../../components/history/text-receipt-modal.jsx"
import { connect } from "react-redux"

const mapStateToProps = state =>({
  currentTransactionId: state.transactionsHistory.currentTransactionId
})

const mapDispatchToProps = dispatch => ({
  onSend: (data) => dispatch({type: 'SEND_RECEIPT', payload: data})
})

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptModal)
